import FirebaseService from './FirebaseService'

export default class extends FirebaseService {

}

